import React from 'react';
import { motion } from 'framer-motion';
const introPhotos = [{
  src: 'https://cdn.magicpatterns.com/uploads/dT9ca5TJmHe5iJa3FmAtdD/WhatsApp_Image_2026-10-03_at_16.17.33.jpg',
  alt: 'Entry foyer with sculptural timber-clad spiral staircase'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/13KdEbnjt8zLHzMFCbnL54/WhatsApp_Image_2026-10-03_at_16.17.36.jpg',
  alt: 'Double-height bedroom with oak floors and framed treetop view'
}];
const fadeUp = {
  hidden: {
    opacity: 0,
    y: 40
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 1.1,
      ease: [0.16, 1, 0.3, 1]
    }
  }
};
/**
 * Quiet editorial text breaker between the hero and the first content
 * section — sets the tone before the imagery resumes.
 */
export function IntroBreaker() {
  return <section className="w-full bg-bg-warm px-6 md:px-14 py-20 md:py-36 relative z-10" data-id="element-106" data-mp="25sskdkhqx5ap">
      <motion.div initial="hidden" whileInView="visible" viewport={{
      once: true,
      margin: '-100px'
    }} variants={{
      visible: {
        transition: {
          staggerChildren: 0.15
        }
      }
    }} className="max-w-4xl mx-auto text-center" data-id="element-107" data-mp="20tfo694zilvg">
        <motion.h2 variants={fadeUp} className="font-heading text-3xl md:text-6xl font-light tracking-tight text-primary leading-[1.1]" data-id="element-108" data-mp="3tc867kbn8uod">
          Your future home awaits.
        </motion.h2>
        <motion.p variants={fadeUp} className="mt-6 md:mt-8 text-lg md:text-2xl font-light leading-relaxed text-text-muted max-w-3xl mx-auto" data-id="element-109" data-mp="b3z8499xgwmy">
          Campanilla is a 610 sqm residence in Ayala Westgrove Heights, designed
          for natural light, seamless flow, and unobstructed views, transforming
          your everyday into living art.
        </motion.p>
      </motion.div>

      {/* Actual photos */}
      <div className="max-w-6xl mx-auto mt-14 md:mt-24 grid grid-cols-1 sm:grid-cols-2 gap-6 md:gap-10 items-start" data-id="element-110" data-mp="tvi96ake60mc">
        {introPhotos.map((photo, i) => <motion.figure key={photo.src} variants={fadeUp} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-80px'
      }} className={`overflow-hidden ${i === 1 ? 'sm:mt-20 md:mt-32' : ''}`} data-id="element-111" data-mp="2lwji4hmf0c1l" data-mpi={i}>
            <img src={photo.src} alt={photo.alt} loading="lazy" className="w-full aspect-[3/4] object-cover" data-id="element-112" data-mp="39kj8vhjq82g6" />
          </motion.figure>)}
      </div>
    </section>;
}